import React, { useState, useEffect } from "react";
import {
  ProductCard,
  ProductImage,
  ProductImageWrapper,
  Text,
  TextBold,
} from "./styles";
import styles from "./product.module.css";
import { Card } from "react-bootstrap";
import { IoIosAdd } from "react-icons/io";
import ContentLoader from "react-content-loader";
import ImageWithPlaceholder from "../../common/ImageWithPlaceholder";

const ProductItem = ({ product, setSelectedProduct, setShowModal }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [showProductImage, setShowProductImage] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };
    handleResize(); // Check on mount
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    let interval;
    let timeout;
    const startRotation = () => {
      interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % product.images.length;
          if (nextIndex === 0) {
            // When the rotation is complete, show product.image
            setShowProductImage(true);
            timeout = setTimeout(() => {
              setShowProductImage(false);
            }, 3000); // Adjust the delay as needed
          }
          return nextIndex;
        });
      }, 3000); // Change image every 2 seconds
    };

    if ((isHovered || isMobileView) && product.images.length > 0) {
      // Show product.image for 3 seconds
      timeout = setTimeout(() => {
        setShowProductImage(false);
        startRotation();
      }, 3000);
    }
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isHovered, isMobileView, product.images]);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setCurrentImageIndex(0); // Reset to the first image
    setShowProductImage(true); // Show product.image again
  };

  const handleCardClick = () => {
    if (!product.outOfStock) {
      setSelectedProduct(product);
      setShowModal(true);
    }
  };

  return (
    <ProductCard
      onClick={handleCardClick}
      className={product.outOfStock ? styles.disabledProduct : ""}
    >
      <ProductImageWrapper
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
         {product.outOfStock && (
          <span className={styles.soldOut}>Sold Out</span>
        )}
        <ImageWithPlaceholder
          as={ProductImage}
          variant="top"
          src={
            (isHovered || isMobileView) && product.images.length && !showProductImage
              ? product.images[currentImageIndex]
              : product.image
          }
          alt={product.name}
          wrapperStyle={{ position: "absolute", inset: 0, display: "block" }}
        />
        {!product.image && (
          <ContentLoader
            speed={2}
            width={200}
            height={200}
            viewBox="0 0 200 200"
            backgroundColor="#F2F2F2"
            foregroundColor="#F2F2F2"
          >
            <rect x="0" y="0" rx="10" ry="10" width="200" height="200" />
          </ContentLoader>
        )}
        <div className="icon-wrapper">
          <IoIosAdd size={30} color="white" />
        </div>
       
      </ProductImageWrapper>
      <Card.Body>
        <TextBold className={styles.itemName}>{product.name}</TextBold>
        <Text className={styles.itemPrice}>
          ₦{" "}
          {new Intl.NumberFormat("en-NG", {
            style: "decimal",
            maximumFractionDigits: 2,
          }).format(product.price)}
        </Text>
      </Card.Body>
    </ProductCard>
  );
};

export default ProductItem;